import {DomainObject} from 'shared/store';
import {observable, makeObservable} from 'mobx';

class WidgetLayout extends DomainObject {
  layout;

  constructor(other) {
    super();

    makeObservable(this, {
      layout: observable
    });

    this.merge(other);
  }
}

export default WidgetLayout;
